<template>
  <v-app>
    <v-main>
      <v-container fill-height fluid>
        <v-row align="center"
            justify="center">
            <v-col cols="12">
              <v-row
                :align="alignment"
                :justify="justify"
              >
                <slot />
              </v-row>
            </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    alignment: {
      type: String,
      default: 'center',
      validator: (value) => ['start', 'center', 'end', 'baseline', 'stretch'].includes(value),
    },
    justify: {
      type: String,
      default: 'center',
      validator: (value) => ['start', 'center', 'end', 'space-around', 'space-between'].includes(value),
    },
  },
};
</script>
